const __DEV__ = false;

var makeId = function makeId() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return args.filter(function (val) {
    return val != null;
  }).join('--');
};
var makeId$1 = makeId;

export { makeId$1 as default };
//# sourceMappingURL=make-id.js.map
